<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8IV5sz/tc-custom/9781504050562.jpg?1734217497408" alt="This image is the cover for the book First Come, First Kill, The Captain Heimrich Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">First Come, First Kill, The Captain Heimrich Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Murder follows Captain Heimrich home in this classic mystery from the authors of the “excellent” Mr. and Mrs. North series (<i>The New Yorker</i>).</b><br/>  <br/> Capt. M. L. Heimrich of the New York State Police may not have the flash of hard-boiled city detectives, but there’s no lead the intrepid investigator won’t follow until his every hunch is satisfied . . .<br/>  <br/> A police captain’s driveway is the last place anyone would expect to find a dead body. But when a man who’s been shot collapses in front of Captain Heimrich’s wife, it seems murder has landed directly on the detective’s doorstep.<br/>  <br/> The victim turns out to be Old Tom, a vagabond who did odd jobs around the town of Van Brunt, New York. Then, a shocking truth emerges: Old Tom was T. Lyman Mitchell, a justice of the New York Supreme Court who’s been missing for six years.<br/>  <br/> Heimrich needs to figure out the reason for the justice’s sudden reappearance in order to determine who shot him. Maybe it has to do with a criminal he once convicted. Or maybe it involves his wife, who wants to move on with a new husband. With so many avenues to investigate, Heimrich must race to find the ruthless killer before anyone else bites the bullet . . .<br/>  <br/> First Come, First Kill <i>is the 14th book in the Captain Heimrich Mysteries, but you may enjoy reading the series in any order.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frances Lockridge, Richard Lockridge
      </h2>
      
      <p class="authorDescription body article">Frances and Richard Lockridge were some of the most popular names in mystery during the forties and fifties. Having written numerous novels and stories, the husband-and-wife team was most famous for their Mr. and Mrs. North Mysteries. What started in 1936 as a series of stories written for the <I>New Yorker</I> turned into twenty-six novels, including adaptions for Broadway, film, television, and radio. The Lockridges continued writing together until Frances&rsquo;s death in 1963, after which Richard discontinued the Mr. and Mrs. North series and wrote other works until his own death in 1982.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress.com/Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?04d4998f